import * as l from "react";
import i, { useEffect as H, useState as V, useRef as Z, useCallback as I, useMemo as O, Suspense as Ct } from "react";
import { useFragment as St, usePreloadedQuery as Et, useQueryLoader as zt } from "react-relay";
import { u as T, p as It } from "./contexts-BZGAPJKE.mjs";
import { g as Lt } from "./index-DUTDaDpU.mjs";
import { html as fe } from "common-tags";
import { useSyncedRef as Tt, useTimeoutEffect as Qe, useMountEffect as ee, useList as $t } from "@react-hookz/web";
import { g as Pt, n as ie, s as Nt, h as Ot, j as Rt, i as Ft, b as At } from "./index-CnymUPx7.mjs";
import { a as oe, g as jt } from "./environment-BQ4WWa7b.mjs";
import { h as c, i as Mt, N as Ht, V as qt, j as Dt } from "./index-CJx5uIQY.mjs";
import { Modal as Bt } from "@mui/material";
import { Z as Gt } from "./z-index-CEuzp1gH.mjs";
import { b as Y, f as C, g as Ne, a as Kt } from "./variables-BSQ2K9t-.mjs";
import te from "qs";
import { css as L } from "@emotion/react";
import Ut, { Element as Wt } from "html-react-parser";
import * as Oe from "@product/scmp-account-sdk";
const Ve = {
  fragment: {
    argumentDefinitions: [],
    kind: "Fragment",
    metadata: null,
    name: "displayAcquisitionPopupContainerQuery",
    selections: [{
      args: null,
      kind: "FragmentSpread",
      name: "hooksUseAcquisitionPopupQuery"
    }],
    type: "Query",
    abstractKey: null
  },
  kind: "Request",
  operation: {
    argumentDefinitions: [],
    kind: "Operation",
    name: "displayAcquisitionPopupContainerQuery",
    selections: [{
      alias: "widgetConfig",
      args: [{
        kind: "Literal",
        name: "filter",
        value: {
          entityId: "scmp_pwa_widget"
        }
      }],
      concreteType: "AppConfig",
      kind: "LinkedField",
      name: "appConfig",
      plural: !1,
      selections: [{
        alias: null,
        args: null,
        kind: "ScalarField",
        name: "json",
        storageKey: null
      }, {
        alias: null,
        args: null,
        kind: "ScalarField",
        name: "id",
        storageKey: null
      }],
      storageKey: 'appConfig(filter:{"entityId":"scmp_pwa_widget"})'
    }]
  },
  params: {
    cacheID: "313464f632aa4a7ebcf48c588c7b77c3",
    id: null,
    metadata: {},
    name: "displayAcquisitionPopupContainerQuery",
    operationKind: "query",
    text: `query displayAcquisitionPopupContainerQuery {
  ...hooksUseAcquisitionPopupQuery
}

fragment hooksUseAcquisitionPopupQuery on Query {
  widgetConfig: appConfig(filter: {entityId: "scmp_pwa_widget"}) {
    json
    id
  }
}
`
  }
};
Ve.hash = "3ff4df315a1765e4d99b01b77df32294";
let W = /* @__PURE__ */ function(e) {
  return e.AcquisitionNewsletter = "acquisition-newsletter", e.Campaign = "campaign", e.MyNewsCompletion = "my-news-completion", e.TopicPackageFollow = "topic-package-follow", e.WhyRegister = "why-register", e;
}({});
const Ze = {
  argumentDefinitions: [],
  kind: "Fragment",
  metadata: null,
  name: "hooksUseAcquisitionPopupQuery",
  selections: [{
    alias: "widgetConfig",
    args: [{
      kind: "Literal",
      name: "filter",
      value: {
        entityId: "scmp_pwa_widget"
      }
    }],
    concreteType: "AppConfig",
    kind: "LinkedField",
    name: "appConfig",
    plural: !1,
    selections: [{
      alias: null,
      args: null,
      kind: "ScalarField",
      name: "json",
      storageKey: null
    }],
    storageKey: 'appConfig(filter:{"entityId":"scmp_pwa_widget"})'
  }],
  type: "Query",
  abstractKey: null
};
Ze.hash = "e9738b90264ec450dc22909225ffbc57";
const Qt = {
  button: {
    inMyNewsText: "START READING",
    otherPageText: fe`Go to <i style="font-weight: 400;">my</i><b>NEWS</b>`
  },
  description: fe`
    You can now
    <ul>
      <li>access your <b>Daily 5</b> must-read articles</li>
      <li>
        access <i style="font-weight: 400;">my</i><b>NEWS</b> via the <b>SCMP app</b>. <wbr />Simply
        <download-link>download</download-link> and log in
      </li>
    </ul>
  `,
  headline: fe`<i style="font-weight: 400;">my</i><b>NEWS</b> set-up is complete`,
  localStorageKey: "isShownMyNewsCompletionPopup"
}, Vt = {
  completion: Qt
}, Zt = (e, t) => {
  var n;
  const {
    acquisition: {
      setPopupState: a
    }
  } = T(), o = St(Ze, t);
  H(() => {
    var r;
    if (!(o != null && (r = o.widgetConfig) !== null && r !== void 0 && r.json)) return;
    const g = o.widgetConfig.json[e.configEnvironmentSlug], m = Object.entries(g).reduce((h, [f, y]) => {
      const s = f.toUpperCase();
      return s.startsWith("ACQUISITION_NL_") ? h.acquisitions[f] = y : s.startsWith("ACQUISITION_WHY_REGISTER_") ? h.whyRegister[f] = y : s.startsWith("CAMPAIGN_POPUP_") ? h.campaigns[f] = y : s.startsWith("TOPIC_PACKAGE_FOLLOW_POPUP_") && (h.topicPackageFollows[f] = y), h;
    }, {
      acquisitions: {},
      campaigns: {},
      myNews: {
        config: g == null ? void 0 : g.my_news,
        ...Vt
      },
      topicPackageFollows: {},
      whyRegister: {}
    });
    a(m);
  }, [o == null || (n = o.widgetConfig) === null || n === void 0 ? void 0 : n.json, e.configEnvironmentSlug, a]);
};
function Yt(e, t) {
  for (var n = -1, a = e == null ? 0 : e.length, o = Array(a); ++n < a; )
    o[n] = t(e[n], n, e);
  return o;
}
var Ye = Yt, Jt = typeof oe == "object" && oe && oe.Object === Object && oe, Xt = Jt, en = Xt, tn = typeof self == "object" && self && self.Object === Object && self, nn = en || tn || Function("return this")(), ze = nn, an = ze, on = an.Symbol, Je = on, Re = Je, Xe = Object.prototype, rn = Xe.hasOwnProperty, ln = Xe.toString, Q = Re ? Re.toStringTag : void 0;
function sn(e) {
  var t = rn.call(e, Q), n = e[Q];
  try {
    e[Q] = void 0;
    var a = !0;
  } catch {
  }
  var o = ln.call(e);
  return a && (t ? e[Q] = n : delete e[Q]), o;
}
var cn = sn, pn = Object.prototype, un = pn.toString;
function gn(e) {
  return un.call(e);
}
var dn = gn, Fe = Je, mn = cn, fn = dn, hn = "[object Null]", yn = "[object Undefined]", Ae = Fe ? Fe.toStringTag : void 0;
function vn(e) {
  return e == null ? e === void 0 ? yn : hn : Ae && Ae in Object(e) ? mn(e) : fn(e);
}
var bn = vn;
function xn(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var et = xn, wn = bn, _n = et, kn = "[object AsyncFunction]", Cn = "[object Function]", Sn = "[object GeneratorFunction]", En = "[object Proxy]";
function zn(e) {
  if (!_n(e))
    return !1;
  var t = wn(e);
  return t == Cn || t == Sn || t == kn || t == En;
}
var tt = zn, In = ze, Ln = In["__core-js_shared__"], Tn = Ln, he = Tn, je = function() {
  var e = /[^.]+$/.exec(he && he.keys && he.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function $n(e) {
  return !!je && je in e;
}
var Pn = $n, Nn = Function.prototype, On = Nn.toString;
function Rn(e) {
  if (e != null) {
    try {
      return On.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Fn = Rn, An = tt, jn = Pn, Mn = et, Hn = Fn, qn = /[\\^$.*+?()[\]{}|]/g, Dn = /^\[object .+?Constructor\]$/, Bn = Function.prototype, Gn = Object.prototype, Kn = Bn.toString, Un = Gn.hasOwnProperty, Wn = RegExp(
  "^" + Kn.call(Un).replace(qn, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Qn(e) {
  if (!Mn(e) || jn(e))
    return !1;
  var t = An(e) ? Wn : Dn;
  return t.test(Hn(e));
}
var Vn = Qn;
function Zn(e, t) {
  return e == null ? void 0 : e[t];
}
var Yn = Zn, Jn = Vn, Xn = Yn;
function ea(e, t) {
  var n = Xn(e, t);
  return Jn(n) ? n : void 0;
}
var Ie = ea, ta = Ie, na = ta(Object, "create"), ce = na, Me = ce;
function aa() {
  this.__data__ = Me ? Me(null) : {}, this.size = 0;
}
var oa = aa;
function ia(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var ra = ia, la = ce, sa = "__lodash_hash_undefined__", ca = Object.prototype, pa = ca.hasOwnProperty;
function ua(e) {
  var t = this.__data__;
  if (la) {
    var n = t[e];
    return n === sa ? void 0 : n;
  }
  return pa.call(t, e) ? t[e] : void 0;
}
var ga = ua, da = ce, ma = Object.prototype, fa = ma.hasOwnProperty;
function ha(e) {
  var t = this.__data__;
  return da ? t[e] !== void 0 : fa.call(t, e);
}
var ya = ha, va = ce, ba = "__lodash_hash_undefined__";
function xa(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = va && t === void 0 ? ba : t, this;
}
var wa = xa, _a = oa, ka = ra, Ca = ga, Sa = ya, Ea = wa;
function D(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
D.prototype.clear = _a;
D.prototype.delete = ka;
D.prototype.get = Ca;
D.prototype.has = Sa;
D.prototype.set = Ea;
var za = D;
function Ia() {
  this.__data__ = [], this.size = 0;
}
var La = Ia;
function Ta(e, t) {
  return e === t || e !== e && t !== t;
}
var $a = Ta, Pa = $a;
function Na(e, t) {
  for (var n = e.length; n--; )
    if (Pa(e[n][0], t))
      return n;
  return -1;
}
var pe = Na, Oa = pe, Ra = Array.prototype, Fa = Ra.splice;
function Aa(e) {
  var t = this.__data__, n = Oa(t, e);
  if (n < 0)
    return !1;
  var a = t.length - 1;
  return n == a ? t.pop() : Fa.call(t, n, 1), --this.size, !0;
}
var ja = Aa, Ma = pe;
function Ha(e) {
  var t = this.__data__, n = Ma(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var qa = Ha, Da = pe;
function Ba(e) {
  return Da(this.__data__, e) > -1;
}
var Ga = Ba, Ka = pe;
function Ua(e, t) {
  var n = this.__data__, a = Ka(n, e);
  return a < 0 ? (++this.size, n.push([e, t])) : n[a][1] = t, this;
}
var Wa = Ua, Qa = La, Va = ja, Za = qa, Ya = Ga, Ja = Wa;
function B(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
B.prototype.clear = Qa;
B.prototype.delete = Va;
B.prototype.get = Za;
B.prototype.has = Ya;
B.prototype.set = Ja;
var Xa = B, eo = Ie, to = ze, no = eo(to, "Map"), ao = no, He = za, oo = Xa, io = ao;
function ro() {
  this.size = 0, this.__data__ = {
    hash: new He(),
    map: new (io || oo)(),
    string: new He()
  };
}
var lo = ro;
function so(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var co = so, po = co;
function uo(e, t) {
  var n = e.__data__;
  return po(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var ue = uo, go = ue;
function mo(e) {
  var t = go(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var fo = mo, ho = ue;
function yo(e) {
  return ho(this, e).get(e);
}
var vo = yo, bo = ue;
function xo(e) {
  return bo(this, e).has(e);
}
var wo = xo, _o = ue;
function ko(e, t) {
  var n = _o(this, e), a = n.size;
  return n.set(e, t), this.size += n.size == a ? 0 : 1, this;
}
var Co = ko, So = lo, Eo = fo, zo = vo, Io = wo, Lo = Co;
function G(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
G.prototype.clear = So;
G.prototype.delete = Eo;
G.prototype.get = zo;
G.prototype.has = Io;
G.prototype.set = Lo;
var To = G, $o = "__lodash_hash_undefined__";
function Po(e) {
  return this.__data__.set(e, $o), this;
}
var No = Po;
function Oo(e) {
  return this.__data__.has(e);
}
var Ro = Oo, Fo = To, Ao = No, jo = Ro;
function se(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new Fo(); ++t < n; )
    this.add(e[t]);
}
se.prototype.add = se.prototype.push = Ao;
se.prototype.has = jo;
var Mo = se;
function Ho(e, t, n, a) {
  for (var o = e.length, r = n + (a ? 1 : -1); a ? r-- : ++r < o; )
    if (t(e[r], r, e))
      return r;
  return -1;
}
var qo = Ho;
function Do(e) {
  return e !== e;
}
var Bo = Do;
function Go(e, t, n) {
  for (var a = n - 1, o = e.length; ++a < o; )
    if (e[a] === t)
      return a;
  return -1;
}
var Ko = Go, Uo = qo, Wo = Bo, Qo = Ko;
function Vo(e, t, n) {
  return t === t ? Qo(e, t, n) : Uo(e, Wo, n);
}
var Zo = Vo, Yo = Zo;
function Jo(e, t) {
  var n = e == null ? 0 : e.length;
  return !!n && Yo(e, t, 0) > -1;
}
var Xo = Jo;
function ei(e, t, n) {
  for (var a = -1, o = e == null ? 0 : e.length; ++a < o; )
    if (n(t, e[a]))
      return !0;
  return !1;
}
var ti = ei;
function ni(e) {
  return function(t) {
    return e(t);
  };
}
var ai = ni;
function oi(e, t) {
  return e.has(t);
}
var ii = oi, ri = Mo, li = Xo, si = ti, ci = Ye, pi = ai, qe = ii, ui = Math.min;
function gi(e, t, n) {
  for (var a = n ? si : li, o = e[0].length, r = e.length, p = r, g = Array(r), m = 1 / 0, h = []; p--; ) {
    var f = e[p];
    p && t && (f = ci(f, pi(t))), m = ui(f.length, m), g[p] = !n && (t || o >= 120 && f.length >= 120) ? new ri(p && f) : void 0;
  }
  f = e[0];
  var y = -1, s = g[0];
  e:
    for (; ++y < o && h.length < m; ) {
      var d = f[y], u = t ? t(d) : d;
      if (d = n || d !== 0 ? d : 0, !(s ? qe(s, u) : a(h, u, n))) {
        for (p = r; --p; ) {
          var v = g[p];
          if (!(v ? qe(v, u) : a(e[p], u, n)))
            continue e;
        }
        s && s.push(u), h.push(d);
      }
    }
  return h;
}
var di = gi;
function mi(e) {
  return e;
}
var nt = mi;
function fi(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var hi = fi, yi = hi, De = Math.max;
function vi(e, t, n) {
  return t = De(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var a = arguments, o = -1, r = De(a.length - t, 0), p = Array(r); ++o < r; )
      p[o] = a[t + o];
    o = -1;
    for (var g = Array(t + 1); ++o < t; )
      g[o] = a[o];
    return g[t] = n(p), yi(e, this, g);
  };
}
var bi = vi;
function xi(e) {
  return function() {
    return e;
  };
}
var wi = xi, _i = Ie, ki = function() {
  try {
    var e = _i(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Ci = ki, Si = wi, Be = Ci, Ei = nt, zi = Be ? function(e, t) {
  return Be(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Si(t),
    writable: !0
  });
} : Ei, Ii = zi, Li = 800, Ti = 16, $i = Date.now;
function Pi(e) {
  var t = 0, n = 0;
  return function() {
    var a = $i(), o = Ti - (a - n);
    if (n = a, o > 0) {
      if (++t >= Li)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var Ni = Pi, Oi = Ii, Ri = Ni, Fi = Ri(Oi), Ai = Fi, ji = nt, Mi = bi, Hi = Ai;
function qi(e, t) {
  return Hi(Mi(e, t, ji), e + "");
}
var Di = qi, Bi = 9007199254740991;
function Gi(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Bi;
}
var Ki = Gi, Ui = tt, Wi = Ki;
function Qi(e) {
  return e != null && Wi(e.length) && !Ui(e);
}
var Vi = Qi;
function Zi(e) {
  return e != null && typeof e == "object";
}
var Yi = Zi, Ji = Vi, Xi = Yi;
function er(e) {
  return Xi(e) && Ji(e);
}
var tr = er, nr = tr;
function ar(e) {
  return nr(e) ? e : [];
}
var or = ar, ir = Ye, rr = di, lr = Di, sr = or, cr = lr(function(e) {
  var t = ir(e, sr);
  return t.length && t[0] === e[0] ? rr(t) : [];
}), pr = cr;
const ur = /* @__PURE__ */ jt(pr), gr = ["action"], at = 24 * 60 * 60 * 1e3, dr = ({
  geoTargeting: e,
  userCountry: t
}) => {
  if (!e)
    return !0;
  const {
    type: n,
    userCountries: a
  } = e;
  if (a.length === 0)
    return !0;
  switch (n) {
    case "exclude":
      return !a.includes(t);
    case "include":
      return a.includes(t);
    default:
      return !0;
  }
}, mr = ({
  location: e,
  pageTargeting: t
}) => {
  if (!e || !t)
    return !0;
  const {
    excludedPathnameRegexList: n,
    excludedURLList: a,
    includedPathnameRegexList: o,
    includedURLList: r
  } = t, p = !n || n.every((f) => !new RegExp(f).test(e.pathname)), g = !a || a.every((f) => !e.href.includes(f)), m = !o || o.length === 0 || o.some((f) => new RegExp(f).test(e.pathname)), h = !r || r.length === 0 || r.some((f) => e.href.includes(f));
  return p && g && m && h;
}, fr = ({
  userTypeIds: e,
  userTypeTargeting: t
}) => ie(t) ? ie(e) ? ie(ur(e, t)) : !1 : !0, J = ({
  config: e,
  userInfo: t
}) => {
  var n, a;
  const o = [e.localStorageKey, ...(n = e.disableWithLocalStorageKeys) !== null && n !== void 0 ? n : []].every((h) => localStorage.getItem(h) === null), r = dr({
    geoTargeting: e.geoTargeting,
    userCountry: t.userCountry
  }), p = mr({
    location: (a = Pt()) === null || a === void 0 ? void 0 : a.location,
    pageTargeting: e.pageTargeting
  }), g = fr({
    userTypeIds: t.userTypeIds,
    userTypeTargeting: e.userTypeTargeting
  }), m = e.anonymous && !t.isLoggedIn || e.login && t.isLoggedIn;
  return o && r && p && g && m;
}, ge = (e) => {
  const {
    campaignName: t,
    type: n
  } = e;
  return {
    description: `Log in or register to follow <span class="bold-text">${t}</span> and get notified on newly published stories.`,
    title: `Get notified on your favourite ${n}`
  };
}, hr = () => {
  const e = sessionStorage.getItem("popupShownTimestamp");
  return e ? Number.parseInt(e, 10) : null;
}, Ge = () => {
  const e = Date.now() + at;
  sessionStorage.setItem("popupShownTimestamp", e.toString());
}, yr = (e) => Date.now() - e > at, vr = (e, t) => {
  const {
    acquisition: {
      popupState: n
    },
    currentRouteWithoutQuerystring: a
  } = T(), {
    setWithTTL: o
  } = br(), [r, p] = V(!1), [g, m] = V(), h = Z(!1), f = Z(!1), y = Tt(g), s = 5e3;
  Qe(() => {
    p(!0);
  }, s);
  const d = I(() => {
    const u = Object.values(e).flatMap((w) => {
      var S;
      return (S = w.getNextFromAction) !== null && S !== void 0 ? S : [];
    });
    for (const w of u) {
      const b = w(() => {
        b != null && b.localStorageKey && !b.updateLocalStorageOnShow && o(b.localStorageKey), m(void 0);
      });
      if (b) {
        f.current = !0, m(b), b.updateLocalStorageOnShow && o(b.localStorageKey);
        return;
      }
    }
    if (!r || t.skipTriggerFromConfig) return;
    const v = hr();
    if (v !== null && !yr(v)) return;
    const x = Object.values(e).map((w) => w.getNextFromConfig);
    for (const w of x) {
      const b = w(() => {
        b != null && b.localStorageKey && !b.updateLocalStorageOnShow && o(b.localStorageKey), h.current = !1, m(void 0);
      });
      if (b) {
        var $;
        h.current = !0, setTimeout(() => {
          m(b), Ge(), b.updateLocalStorageOnShow && o(b.localStorageKey);
        }, Math.max((($ = b.delay) !== null && $ !== void 0 ? $ : 0) - s, 0));
        return;
      }
    }
    const k = Object.values(e).flatMap((w) => {
      var S;
      return (S = w.getNextFromScrollPosition) !== null && S !== void 0 ? S : [];
    });
    for (const w of k) {
      const b = w(() => {
        b != null && b.localStorageKey && !b.updateLocalStorageOnShow && o(b.localStorageKey), m(void 0);
      });
      if (b) {
        m(b), Ge(), b.updateLocalStorageOnShow && o(b.localStorageKey);
        return;
      }
    }
  }, [r, e, o, t.skipTriggerFromConfig]);
  return H(() => {
    h.current || f.current || !a || y.current !== void 0 || !Object.values(n).some((u) => ie(u)) || d();
  }, [a, y, n, d]), {
    popup: y.current
  };
}, br = () => {
  const e = I((t) => {
    Nt(t, Ot(/* @__PURE__ */ new Date(), 90).toISOString());
  }, []);
  return ee(() => {
    for (const [a] of Object.entries(localStorage).filter(([o]) => ["ACQUISITION", "CAMPAIGN", "TOPIC_PACKAGE"].some((r) => o.startsWith(r)))) {
      var t, n;
      if (!Rt(new Date((t = localStorage.getItem(a)) !== null && t !== void 0 ? t : ""))) {
        e(a);
        continue;
      }
      Ft(/* @__PURE__ */ new Date(), (n = localStorage.getItem(a)) !== null && n !== void 0 ? n : "") && localStorage.removeItem(a);
    }
  }), {
    setWithTTL: e
  };
}, xr = (e) => /* @__PURE__ */ l.createElement("svg", { fill: "#fff", width: 16, height: 16, viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { d: "M16 .611L15.426 0 8 7.408.612 0 0 .611l7.388 7.408L0 15.39l.612.61L8 8.592 15.426 16l.574-.611-7.388-7.37z", fillRule: "evenodd" })), wr = /* @__PURE__ */ c(xr, {
  target: "e1yvcnez0"
})({
  name: "12n878b",
  styles: "position:absolute;inset-block-start:-10px;inset-inline-end:-10px;inline-size:24px;block-size:24px;padding:4px;border-radius:50%;background-color:#222222;cursor:pointer"
}), K = ({
  onClose: e
}) => /* @__PURE__ */ i.createElement(wr, {
  onClick: e,
  "data-qa": "close-button"
});
K.displayName = "CloseButton";
const Le = /* @__PURE__ */ c("div", {
  target: "e1d54s182"
})({
  name: "nwi359",
  styles: "position:fixed;inset-block:0 0;inset-inline:0 0;z-index:-1;opacity:0.8;-webkit-tap-highlight-color:transparent"
}), _r = /* @__PURE__ */ c(Le, {
  target: "e1d54s181"
})({
  name: "qr3hfl",
  styles: "background-color:#27303e"
}), kr = /* @__PURE__ */ c(Le, {
  target: "e1d54s180"
})({
  name: "pz9wym",
  styles: "background-color:#ffffff"
}), ne = /* @__PURE__ */ c(Le, {
  target: "e17jtchq0"
})({
  name: "taq9ah",
  styles: "background:#000000;opacity:0.5"
}), Cr = /* @__PURE__ */ c(Bt, {
  target: "evs3m4a0"
})("z-index:", Gt.Modal, ";display:flex;justify-content:center;align-items:center;-webkit-tap-highlight-color:transparent;*,*::before,*::after{box-sizing:border-box;outline:none;}");
function ye() {
  return ye = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) ({}).hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  }, ye.apply(null, arguments);
}
const U = ({
  backdropColor: e,
  BackdropComponent: t,
  children: n,
  fadeTimeout: a,
  ...o
}) => /* @__PURE__ */ i.createElement(Cr, ye({}, o, {
  closeAfterTransition: !0,
  slots: {
    backdrop: t ?? (e === "light" ? kr : _r)
  },
  "data-qa": "modal"
}), /* @__PURE__ */ i.createElement(Mt, {
  in: o.open,
  timeout: a ?? 300
}, n));
U.displayName = "Modal";
const Sr = /* @__PURE__ */ c("div", {
  target: "e9bvxhk4"
})("position:relative;inline-size:280px;max-block-size:476px;margin:auto;background-color:#001246;outline:none;", (e) => e.theme.breakpoints.up("mobile"), "{inline-size:calc(100vw - 40px);max-block-size:670px;}", (e) => e.theme.breakpoints.up("tablet"), "{inline-size:600px;max-block-size:729px;}"), Er = /* @__PURE__ */ c("div", {
  target: "e9bvxhk3"
})("display:flex;justify-content:center;align-items:center;inline-size:100%;block-size:100%;max-block-size:187px;overflow:hidden;", (e) => e.theme.breakpoints.up("mobile"), "{block-size:224px;max-block-size:224px;}", (e) => e.theme.breakpoints.up("tablet"), "{inline-size:600px;block-size:400px;max-inline-size:600px;max-block-size:400px;}img{display:block;inline-size:100%;block-size:100%;object-fit:cover;}"), zr = /* @__PURE__ */ c("div", {
  target: "e9bvxhk2"
})("display:flex;flex-flow:column;justify-content:center;align-items:center;inline-size:100%;block-size:289px;padding-block:16px;padding-inline:20px;", (e) => e.theme.breakpoints.up("tablet"), "{block-size:250px;max-inline-size:600px;padding:40px;}"), Ir = /* @__PURE__ */ c("div", {
  target: "e9bvxhk1"
})("margin-block-end:12px;color:#ffca05;font-size:20px;font-family:", Y, ";line-height:25px;text-align:center;"), Lr = /* @__PURE__ */ c("div", {
  target: "e9bvxhk0"
})("margin-block-end:12px;color:#ffffff;font-size:15px;font-family:", C, ";line-height:19px;text-align:center;span{font-weight:700;}"), ot = ({
  acquisition: e,
  modalContainerReference: t,
  onClose: n
}) => {
  const {
    description: a,
    image: o,
    title: r
  } = e.content, p = O(() => {
    var y, s;
    return (y = e.tid ? [{
      entityId: e.tid,
      name: e.name
    }] : (s = e.tids) === null || s === void 0 ? void 0 : s.map((d) => ({
      entityId: d,
      name: e.name
    }))) !== null && y !== void 0 ? y : [];
  }, [e.name, e.tid, e.tids]), {
    handleTrackGA4: g
  } = T(), [m, h] = V(!1), f = e.campaign;
  return ee(() => {
    g({
      action: "imp",
      category: "promopopup",
      customized_parameters: {
        cta_type: "nl_signup",
        internal_campaign: f,
        step: "1"
      },
      subcategory: ""
    });
  }), /* @__PURE__ */ i.createElement(U, {
    BackdropComponent: ne,
    container: t == null ? void 0 : t.current,
    fadeTimeout: 400,
    open: !0,
    "data-qa": "acquisition-newsletter-popup"
  }, /* @__PURE__ */ i.createElement(Sr, null, /* @__PURE__ */ i.createElement(K, {
    onClose: () => {
      g({
        action: "click",
        category: "promopopup",
        customized_parameters: {
          cta_type: "nl_signup",
          internal_campaign: f,
          message: "close button",
          step: "1"
        },
        subcategory: ""
      }), n == null || n();
    }
  }), /* @__PURE__ */ i.createElement(Er, null, /* @__PURE__ */ i.createElement("img", {
    alt: r,
    src: o
  })), /* @__PURE__ */ i.createElement(zr, null, !m && /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement(Ir, {
    dangerouslySetInnerHTML: {
      __html: r
    }
  }), /* @__PURE__ */ i.createElement(Lr, {
    dangerouslySetInnerHTML: {
      __html: a
    }
  })), /* @__PURE__ */ i.createElement(Ht, {
    campaignName: f,
    multipleNewsletters: !0,
    newsletterItems: p,
    onSuccess: () => {
      h(!0);
    },
    signUpButtonDisplayComponent: e.button.text,
    variant: qt.AcquisitionNewsletterPopup
  }))));
};
ot.displayName = "AcquisitionNewsletterPopup";
const Tr = (e) => {
  const {
    acquisition: {
      popupState: t
    },
    userCountry: n,
    userTypeIds: a
  } = T(), o = I((p) => {
    var g;
    const m = Object.values(t.acquisitions).find((f) => J({
      config: f,
      userInfo: {
        isLoggedIn: e.isLoggedIn,
        userCountry: n ?? "",
        userTypeIds: a
      }
    }));
    if (!m) return;
    const h = {
      acquisition: m,
      modalContainerReference: e.modalContainerReference,
      onClose: p
    };
    return {
      delay: Number.parseInt((g = m.timeout) !== null && g !== void 0 ? g : "0", 10),
      element: /* @__PURE__ */ i.createElement(ot, h),
      localStorageKey: m.localStorageKey,
      updateLocalStorageOnShow: !0
    };
  }, [e.isLoggedIn, e.modalContainerReference, t.acquisitions, n, a]);
  return O(() => ({
    getNextFromConfig: o
  }), [o]);
};
let j = /* @__PURE__ */ function(e) {
  return e.Compact = "compact", e.Full = "full", e.Large = "large", e.Normal = "normal", e.Small = "small", e.Thin = "thin", e;
}({}), P = /* @__PURE__ */ function(e) {
  return e.Dark = "dark", e.Homepage = "homepage", e.Light = "light", e.Style = "magazines-style", e;
}({}), z = /* @__PURE__ */ function(e) {
  return e.Filled = "filled", e.Outlined = "outlined", e.Plain = "plain", e;
}({}), q = /* @__PURE__ */ function(e) {
  return e.BlueIcon = "blue-icon", e.BluePlusIcon = "blue-plus-icon", e.BlueSquareIcon = "blue-square-icon", e.CircleGrayIcon = "circle-gray-icon", e.Text = "text", e;
}({}), X = /* @__PURE__ */ function(e) {
  return e.Follow = "follow", e.Unfollow = "unfollow", e;
}({}), it = /* @__PURE__ */ function(e) {
  return e.Author = "author", e.Section = "section", e.Topic = "topic", e;
}({});
const Te = (e) => Object.values(it).includes(e);
function $r(e) {
  var t;
  const a = (t = te.parse(e, {
    ignoreQueryPrefix: !0
  }).action) === null || t === void 0 ? void 0 : t.follow_campaign;
  if (a)
    return a;
}
function Pr(e) {
  const t = {
    action: {
      follow_campaign: e
    }
  };
  return te.stringify(t, {
    arrayFormat: "comma"
  });
}
const Nr = (e) => /* @__PURE__ */ l.createElement("svg", { width: 18, height: 19, viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("rect", { x: 0.5, y: 1.19922, width: 17, height: 17, rx: 1.5 }), /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.625 14.6992H8.375V10.3242H4V9.07422H8.375V4.69922H9.625V9.07422H14V10.3242H9.625V14.6992Z", fill: "#4585FF" })), Or = (e) => /* @__PURE__ */ l.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.625 10H4.375V5.625H0V4.375H4.375V0H5.625V4.375H10V5.625H5.625V10Z", fill: "#4585FF" })), Rr = (e) => /* @__PURE__ */ l.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", style: {
  margin: "auto",
  background: "none",
  display: "block",
  shapeRendering: "auto"
}, width: "44px", height: "44px", viewBox: "0 0 100 100", preserveAspectRatio: "xMidYMid", ...e }, /* @__PURE__ */ l.createElement("g", { transform: "rotate(0 50 50)" }, /* @__PURE__ */ l.createElement("rect", { x: 47.5, y: 20, rx: 2.5, ry: 2.56, width: 5, height: 16, fill: "#4585ff" }, /* @__PURE__ */ l.createElement("animate", { attributeName: "opacity", values: "1;0", keyTimes: "0;1", dur: "1s", begin: "-0.8888888888888888s", repeatCount: "indefinite" }))), /* @__PURE__ */ l.createElement("g", { transform: "rotate(40 50 50)" }, /* @__PURE__ */ l.createElement("rect", { x: 47.5, y: 20, rx: 2.5, ry: 2.56, width: 5, height: 16, fill: "#4585ff" }, /* @__PURE__ */ l.createElement("animate", { attributeName: "opacity", values: "1;0", keyTimes: "0;1", dur: "1s", begin: "-0.7777777777777778s", repeatCount: "indefinite" }))), /* @__PURE__ */ l.createElement("g", { transform: "rotate(80 50 50)" }, /* @__PURE__ */ l.createElement("rect", { x: 47.5, y: 20, rx: 2.5, ry: 2.56, width: 5, height: 16, fill: "#4585ff" }, /* @__PURE__ */ l.createElement("animate", { attributeName: "opacity", values: "1;0", keyTimes: "0;1", dur: "1s", begin: "-0.6666666666666666s", repeatCount: "indefinite" }))), /* @__PURE__ */ l.createElement("g", { transform: "rotate(120 50 50)" }, /* @__PURE__ */ l.createElement("rect", { x: 47.5, y: 20, rx: 2.5, ry: 2.56, width: 5, height: 16, fill: "#4585ff" }, /* @__PURE__ */ l.createElement("animate", { attributeName: "opacity", values: "1;0", keyTimes: "0;1", dur: "1s", begin: "-0.5555555555555556s", repeatCount: "indefinite" }))), /* @__PURE__ */ l.createElement("g", { transform: "rotate(160 50 50)" }, /* @__PURE__ */ l.createElement("rect", { x: 47.5, y: 20, rx: 2.5, ry: 2.56, width: 5, height: 16, fill: "#4585ff" }, /* @__PURE__ */ l.createElement("animate", { attributeName: "opacity", values: "1;0", keyTimes: "0;1", dur: "1s", begin: "-0.4444444444444444s", repeatCount: "indefinite" }))), /* @__PURE__ */ l.createElement("g", { transform: "rotate(200 50 50)" }, /* @__PURE__ */ l.createElement("rect", { x: 47.5, y: 20, rx: 2.5, ry: 2.56, width: 5, height: 16, fill: "#4585ff" }, /* @__PURE__ */ l.createElement("animate", { attributeName: "opacity", values: "1;0", keyTimes: "0;1", dur: "1s", begin: "-0.3333333333333333s", repeatCount: "indefinite" }))), /* @__PURE__ */ l.createElement("g", { transform: "rotate(240 50 50)" }, /* @__PURE__ */ l.createElement("rect", { x: 47.5, y: 20, rx: 2.5, ry: 2.56, width: 5, height: 16, fill: "#4585ff" }, /* @__PURE__ */ l.createElement("animate", { attributeName: "opacity", values: "1;0", keyTimes: "0;1", dur: "1s", begin: "-0.2222222222222222s", repeatCount: "indefinite" }))), /* @__PURE__ */ l.createElement("g", { transform: "rotate(280 50 50)" }, /* @__PURE__ */ l.createElement("rect", { x: 47.5, y: 20, rx: 2.5, ry: 2.56, width: 5, height: 16, fill: "#4585ff" }, /* @__PURE__ */ l.createElement("animate", { attributeName: "opacity", values: "1;0", keyTimes: "0;1", dur: "1s", begin: "-0.1111111111111111s", repeatCount: "indefinite" }))), /* @__PURE__ */ l.createElement("g", { transform: "rotate(320 50 50)" }, /* @__PURE__ */ l.createElement("rect", { x: 47.5, y: 20, rx: 2.5, ry: 2.56, width: 5, height: 16, fill: "#4585ff" }, /* @__PURE__ */ l.createElement("animate", { attributeName: "opacity", values: "1;0", keyTimes: "0;1", dur: "1s", begin: "0s", repeatCount: "indefinite" })))), Fr = (e) => /* @__PURE__ */ l.createElement("svg", { width: 18, height: 19, viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("rect", { x: 0.5, y: 1.19922, width: 17, height: 17, rx: 1.5, stroke: "#4585FF", fill: "#FFFFFF" }), /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.625 14.6992H8.375V10.3242H4V9.07422H8.375V4.69922H9.625V9.07422H14V10.3242H9.625V14.6992Z", fill: "#4585FF" })), Ar = (e) => /* @__PURE__ */ l.createElement("svg", { width: 18, height: 19, viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("rect", { y: 0.5, width: 18, height: 18, rx: 9, fill: "#CCCCCC" }), /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.9821 6.6586L13.4232 6.125L7.37772 11.8949L4.4964 9.145L3.9375 9.67861L7.3709 12.9554L7.65406 12.698L13.9821 6.6586Z", fill: "black" })), jr = (e) => /* @__PURE__ */ l.createElement("svg", { width: 19, height: 19, viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.98246 9.01754H13.3597V9.98247H9.98246V13.359H9.01753V9.98247H5.64096V9.01754H9.01753V5.64029H9.98246V9.01754ZM18.0351 9.5C18.0351 7.1501 17.2004 5.1395 15.5305 3.46953C13.8605 1.79957 11.8499 0.964927 9.5 0.964927C7.14943 0.964927 5.1395 1.79957 3.46953 3.46953C1.79957 5.1395 0.964927 7.1501 0.964927 9.5C0.964927 11.8506 1.79957 13.8605 3.46953 15.5305C5.1395 17.2004 7.14943 18.0351 9.5 18.0351C11.8499 18.0351 13.8605 17.2004 15.5305 15.5305C17.2004 13.8605 18.0351 11.8506 18.0351 9.5ZM19 9.5C19 12.1227 18.0724 14.3613 16.2172 16.2165C14.3613 18.0724 12.122 19 9.5 19C6.87732 19 4.63871 18.0724 2.7835 16.2165C0.927607 14.3613 0 12.1227 0 9.5C0 6.878 0.927607 4.63871 2.7835 2.78282C4.63871 0.927607 6.87732 0 9.5 0C12.122 0 14.3613 0.927607 16.2172 2.78282C18.0724 4.63871 19 6.878 19 9.5Z", fill: "#BBBBBB" })), Mr = (e) => /* @__PURE__ */ l.createElement("svg", { width: 19, height: 19, viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("circle", { cx: 9.5, cy: 9.5, r: 9.5, fill: "#BBBBBB" }), /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.55311 10.7979L12.5683 6.71313L13.2989 7.45658L8.55158 12.2865L5.70325 9.38862L6.43107 8.65762L8.55311 10.7979Z", fill: "#FBFBFA" })), M = /* @__PURE__ */ c(Rr, {
  target: "eklawst9"
})(""), rt = /* @__PURE__ */ c(Fr, {
  target: "eklawst8"
})(""), lt = /* @__PURE__ */ c(Nr, {
  target: "eklawst7"
})(""), st = /* @__PURE__ */ c(jr, {
  target: "eklawst6"
})(""), ct = /* @__PURE__ */ c(Ar, {
  target: "eklawst5"
})(""), pt = /* @__PURE__ */ c(Mr, {
  target: "eklawst4"
})(""), Hr = /* @__PURE__ */ c("div", {
  target: "eklawst3"
})(""), qr = /* @__PURE__ */ c("span", {
  target: "eklawst2"
})({
  name: "1kfe4k0",
  styles: "margin-inline-start:2px"
}), Dr = /* @__PURE__ */ c(Or, {
  target: "eklawst1"
})(""), Br = ({
  isLoading: e,
  outline: t
}) => t === z.Plain ? "transparent" : e ? "#4585ff" : "#cccccc";
var Gr = {
  name: "1kf7pap",
  styles: "color:#ffffff;border-color:transparent;background-color:transparent"
}, Kr = {
  name: "1p9zvdh",
  styles: "color:#ffffff;border-color:#ffffff;background-color:transparent"
}, Ur = {
  name: "tjemjh",
  styles: "color:#ffffff;border-color:#001246;background-color:#001246"
}, Wr = {
  name: "ynfxy1",
  styles: "color:#000000;border-color:transparent;background-color:transparent"
}, Qr = {
  name: "1r9f287",
  styles: "color:#4585ff;border-color:#4585ff;background-color:transparent"
}, Vr = {
  name: "tjemjh",
  styles: "color:#ffffff;border-color:#001246;background-color:#001246"
};
const Zr = /* @__PURE__ */ c("button", {
  target: "eklawst0"
})("display:inline-flex;justify-content:center;align-items:center;text-transform:uppercase;border-style:solid;border-width:", (e) => e.outline === z.Plain ? "0" : "1px", ";border-radius:2px;", rt, ",", lt, ",", st, ",", ct, ",", pt, "{inline-size:18px;block-size:18px;}", (e) => {
  switch (e.size) {
    case j.Compact:
      return /* @__PURE__ */ L("inline-size:fit-content;padding:0;font-size:13px;font-family:", C, ";line-height:15px;white-space:nowrap;overflow:hidden;", M, "{inline-size:15px;block-size:15px;margin-block:auto;}", "");
    case j.Full:
      return /* @__PURE__ */ L("inline-size:100%;padding-block:6px;font-size:12px;font-family:", C, ";line-height:14px;", M, "{inline-size:14px;block-size:14px;margin-block:auto;}", "");
    case j.Large:
      return /* @__PURE__ */ L("inline-size:106px;block-size:36px;padding-block:10px;font-size:14px;font-family:", C, ";line-height:16px;", M, "{inline-size:16px;block-size:16px;margin-block:auto;}", "");
    case j.Small:
      return /* @__PURE__ */ L("inline-size:74px;padding-block:7px;font-size:11px;font-family:", C, ";line-height:11px;", M, "{inline-size:11px;block-size:11px;margin-block:auto;}", "");
    case j.Thin:
      return /* @__PURE__ */ L("inline-size:70px;padding-block:3px;font-size:11px;font-family:", C, ";line-height:13px;", M, "{inline-size:13px;block-size:13px;margin-block:auto;}", "");
    default:
      return /* @__PURE__ */ L("inline-size:94px;padding-block:8px;font-size:12px;font-family:", C, ";line-height:14px;text-align:center;", M, "{inline-size:14px;block-size:14px;margin-block:auto;}", "");
  }
}, " ", (e) => {
  if (!e.isFollowing) return null;
  switch (e.variant) {
    case P.Dark:
      return /* @__PURE__ */ L("color:#001246;border-color:", e.outline === z.Plain ? "transparent" : "#ffffff", ";background-color:", e.outline === z.Plain ? "transparent" : "#ffffff", ";", "");
    case P.Homepage:
      return /* @__PURE__ */ L("color:#000000;border-color:", Br({
        isLoading: e.isLoading,
        outline: e.outline
      }), ";background-color:", e.outline === z.Plain || e.isLoading ? "transparent" : "#cccccc", ";", "");
    case P.Light:
      return /* @__PURE__ */ L("color:#000000;border-color:", e.outline === z.Plain ? "transparent" : "#e5e5e5", ";background-color:", e.outline === z.Plain ? "transparent" : "#e5e5e5", ";", "");
    case P.Style:
      return /* @__PURE__ */ L("inline-size:92px;color:#a1a1a1;font-weight:600;font-family:", Ne, ";letter-spacing:0.36px;border-color:#a1a1a1;border-radius:4px;background-color:#ffffff;", "");
  }
}, " ", (e) => {
  if (e.isFollowing) return null;
  switch (e.variant) {
    case P.Light:
    case P.Homepage:
      switch (e.outline) {
        case z.Filled:
          return Vr;
        case z.Outlined:
          return Qr;
        case z.Plain:
          return Wr;
      }
      break;
    case P.Dark:
      switch (e.outline) {
        case z.Filled:
          return Ur;
        case z.Outlined:
          return Kr;
        case z.Plain:
          return Gr;
      }
      break;
    case P.Style:
      switch (e.outline) {
        case z.Outlined:
          return /* @__PURE__ */ L("inline-size:83px;block-size:30px;padding:0;color:#222222;font-weight:600;font-family:", Ne, ";letter-spacing:0.36px;border-color:#222222;border-radius:4px;background-color:#ffffff;", "");
      }
  }
}, " &:not(:disabled){cursor:pointer;}"), Yr = ({
  className: e,
  disabled: t,
  display: n = q.Text,
  isFollowing: a,
  isLoadingEnabled: o = !1,
  loadingDelay: r = 1500,
  onClick: p,
  outline: g = z.Filled,
  size: m = j.Normal,
  variant: h = P.Light
}) => {
  const [f, y] = V(!1), s = () => {
    p(a ? X.Unfollow : X.Follow);
  };
  Qe(() => {
    y(!1);
  }, f ? r : void 0);
  const d = () => {
    s(), o && y(!0);
  }, u = () => {
    if (f)
      return /* @__PURE__ */ i.createElement(M, null);
    const v = h === P.Homepage ? /* @__PURE__ */ i.createElement(ct, null) : /* @__PURE__ */ i.createElement(pt, null);
    switch (n) {
      case q.BlueIcon:
        return a ? v : /* @__PURE__ */ i.createElement(lt, null);
      case q.BluePlusIcon:
        return a ? "FOLLOWING" : /* @__PURE__ */ i.createElement(Hr, null, /* @__PURE__ */ i.createElement(Dr, null), /* @__PURE__ */ i.createElement(qr, null, "FOLLOW"));
      case q.BlueSquareIcon:
        return a ? v : /* @__PURE__ */ i.createElement(rt, null);
      case q.CircleGrayIcon:
        return a ? v : /* @__PURE__ */ i.createElement(st, null);
      case q.Text:
        return a ? "FOLLOWING" : "+ FOLLOW";
    }
  };
  return /* @__PURE__ */ i.createElement(Zr, {
    className: e,
    disabled: t,
    isFollowing: a,
    isLoading: f,
    onClick: d,
    outline: g,
    size: m,
    variant: h,
    "data-qa": "follow-button"
  }, u());
}, Jr = /* @__PURE__ */ c("a", {
  target: "egvrj6w0"
})("display:block;padding-block:10px;padding-inline:20px;color:#001246;font-size:16px;font-family:", C, ";line-height:19px;text-align:center;text-decoration:none;border-radius:3px;background-color:#ffca05;cursor:pointer;");
function ve() {
  return ve = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) ({}).hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  }, ve.apply(null, arguments);
}
const $e = ({
  children: e,
  className: t,
  onClick: n,
  url: a,
  ...o
}) => {
  const {
    handleRoutePush: r
  } = T();
  return /* @__PURE__ */ i.createElement(Jr, ve({
    className: t,
    onClick: (p) => {
      r(a), n == null || n(p);
    },
    rel: "noreferrer",
    target: "_blank"
  }, o, {
    "data-qa": "redirect-button"
  }), e);
};
$e.displayName = "RedirectButton";
const re = /* @__PURE__ */ c("img", {
  target: "e13oolsl8"
})({
  name: "225k98",
  styles: "inline-size:100%;block-size:100%;object-fit:cover"
}), le = /* @__PURE__ */ c("div", {
  target: "e13oolsl7"
})("display:flex;flex-flow:column;justify-content:center;align-items:center;inline-size:100%;>*+*{margin-block-start:12px;", (e) => e.theme.breakpoints.up("tablet"), "{margin-block-start:8px;}}"), be = /* @__PURE__ */ c("div", {
  target: "e13oolsl6"
})("margin-block-start:0;text-align:center;", (e) => e.theme.breakpoints.up("tablet"), "{margin-inline:20px;}"), xe = /* @__PURE__ */ c("div", {
  target: "e13oolsl5"
})("font-family:", C, ";", (e) => e.theme.breakpoints.up("tablet"), "{margin-inline:20px;}span{font-weight:700;}"), ut = /* @__PURE__ */ c("div", {
  target: "e13oolsl4"
})("max-inline-size:240px;margin-block-end:8px;padding-block:4px;padding-inline:8px;color:#001246;font-weight:700;font-size:14px;font-family:", Kt, ";text-align:center;background-color:#ffca05;", (e) => e.theme.breakpoints.up("mobile"), "{font-size:16px;}"), we = /* @__PURE__ */ c($e, {
  target: "e13oolsl3"
})({
  name: "mmdt3g",
  styles: "font-size:14px"
}), gt = /* @__PURE__ */ c(Yr, {
  target: "e13oolsl2"
})("inline-size:108px;padding-block:10px;padding-inline:20px;font-size:14px;line-height:normal;", (e) => e.theme.breakpoints.up("tablet"), "{inline-size:94px;padding-block:8px;padding-inline:0;line-height:14px;}"), Xr = /* @__PURE__ */ c("div", {
  target: "e13oolsl1"
})("position:relative;display:grid;margin:auto;outline:none;", re, "{grid-area:image;}", le, "{grid-area:content;}", (e) => {
  switch (e.$variant) {
    case "soft":
      return /* @__PURE__ */ L('grid:"content" min-content "image" min-content/100%;background:#f6f6f6;inline-size:calc(100% - 40px);', e.theme.breakpoints.up("mobile"), "{max-inline-size:368px;max-block-size:670px;}", e.theme.breakpoints.up("tablet"), "{max-inline-size:600px;max-block-size:729px;}", le, "{padding-block-start:0;padding-block-end:12px;}", be, "{color:#001246;font-weight:700;font-size:22px;font-family:", C, ";line-height:33px;text-align:center;", e.theme.breakpoints.up("mobile"), "{font-size:28px;}}", xe, "{inline-size:252px;color:#000000;font-size:14px;line-height:18px;text-align:center;", e.theme.breakpoints.up("tablet"), "{inline-size:400px;}}", re, "{padding:4px;block-size:169px;", e.theme.breakpoints.up("tablet"), "{block-size:338px;}}", "");
    default:
      return /* @__PURE__ */ L('grid:"image" min-content "content" min-content/100%;background:#001246;max-inline-size:calc(100% - 40px);', e.theme.breakpoints.up("mobile"), "{max-inline-size:335px;max-block-size:670px;}", e.theme.breakpoints.up("tablet"), "{max-inline-size:600px;max-block-size:729px;}", le, "{padding:16px 20px;", e.theme.breakpoints.up("tablet"), "{padding:0;min-block-size:203px;}}", be, "{color:#ffca05;font-weight:400;font-size:16px;font-family:", Y, ";line-height:normal;", e.theme.breakpoints.up("tablet"), "{font-size:20px;}}", xe, "{color:#ffffff;font-weight:400;font-size:12px;line-height:normal;text-align:center;", e.theme.breakpoints.up("tablet"), "{font-size:16px;}}", ut, "{display:none;}", re, "{block-size:187px;", e.theme.breakpoints.down("mobile"), "{block-size:187px;}", e.theme.breakpoints.up("mobile"), "{block-size:224px;}", e.theme.breakpoints.up("tablet"), "{block-size:400px;}}", we, "{margin-block-start:24px;}", gt, "{margin-block-start:12px;", e.theme.breakpoints.up("tablet"), "{margin-block-start:24px;}}", "");
  }
}, " ", (e) => e.theme.breakpoints.up("tablet"), "{inline-size:600px;max-block-size:729px;}");
function _e() {
  return _e = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) ({}).hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  }, _e.apply(null, arguments);
}
const el = (e) => {
  var t;
  const {
    config: n,
    handleCheckIsFollowed: a,
    handleFollow: o,
    handleOpenLoginDialog: r,
    handleTrackGA4: p,
    user: g
  } = T(), m = (t = e.theme) !== null && t !== void 0 ? t : "follow", h = dt(m);
  return {
    render: (y) => {
      var s, d, u;
      const v = e.name, x = e.campaign;
      switch (m) {
        case "follow":
          if (!Te(e.type)) return;
          const {
            name: $,
            tid: k,
            tids: w = [],
            type: S
          } = e, b = k ? [k] : w, ae = b.every((N) => a({
            entityId: N,
            followType: S
          }));
          return /* @__PURE__ */ i.createElement(gt, _e({}, y.followButtonProps, {
            disabled: ae,
            isFollowing: ae,
            onClick: (N) => {
              if (N !== X.Unfollow) {
                if (p({
                  action: "click",
                  category: "follow",
                  customized_parameters: {
                    action_type: "follow",
                    follow_type: "topic",
                    internal_campaign: x,
                    topic_id: k ?? w.join(", "),
                    trigger_point: "ppto"
                  },
                  subcategory: ""
                }), p({
                  action: "click",
                  category: "promopopup",
                  customized_parameters: {
                    cta_type: h,
                    internal_campaign: x,
                    message: "follow",
                    step: "1"
                  },
                  subcategory: ""
                }), !g) {
                  const F = new URL(window.location.href);
                  F.search = Pr({
                    campaign: $
                  });
                  const {
                    description: de,
                    title: me
                  } = ge({
                    campaignName: v,
                    type: S
                  });
                  r({
                    description: de,
                    destination: F.toString(),
                    ga4CustomParameter: {
                      internal_campaign: x,
                      trigger_point: "ppto"
                    },
                    title: me
                  });
                  return;
                }
                o({
                  action: N,
                  callback: () => {
                    p({
                      action: "sys",
                      category: "follow",
                      customized_parameters: {
                        action_type: "follow",
                        follow_type: "topic",
                        internal_campaign: x,
                        topic_id: k ?? w.join(", "),
                        trigger_point: "ppto"
                      },
                      subcategory: "result"
                    }), y.handlePopupClose && y.handlePopupClose();
                  },
                  entityIds: b,
                  followType: S
                });
              }
            }
          }));
        case "link":
          return /* @__PURE__ */ i.createElement(we, {
            onClick: () => {
              var N, F;
              p({
                action: "click",
                category: "promopopup",
                customized_parameters: {
                  cta_type: h,
                  destination_url: (N = e.content.redirectURL) !== null && N !== void 0 ? N : "",
                  internal_campaign: x,
                  message: (F = e.content.redirectTitle) !== null && F !== void 0 ? F : "",
                  step: "1"
                },
                subcategory: ""
              });
            },
            url: (s = e.content.redirectURL) !== null && s !== void 0 ? s : ""
          }, e.content.redirectTitle);
        case "subscribe":
          const R = new URL(n.subscribe.host);
          return R.searchParams.set("module", `semi-FPTO_${x}`), R.searchParams.set("pgtype", "article"), R.searchParams.set("promocode", (d = e.content.promoCode) !== null && d !== void 0 ? d : ""), R.searchParams.set("plan", (u = e.content.termCode) !== null && u !== void 0 ? u : ""), /* @__PURE__ */ i.createElement(we, {
            onClick: () => {
              p({
                action: "click",
                category: "promopopup",
                customized_parameters: {
                  cta_type: h,
                  internal_campaign: x,
                  message: "Subscribe",
                  step: "1"
                },
                subcategory: ""
              });
            },
            url: R.toString()
          }, "Subscribe");
        default:
          return null;
      }
    }
  };
}, dt = (e) => {
  switch (e) {
    case "follow":
      return "follow";
    case "link":
      return "url_redirect";
    case "subscribe":
      return "subscribe";
    default:
      return "follow";
  }
}, ke = ({
  campaign: e,
  confirmedAction: t,
  modalContainerReference: n,
  onClose: a
}) => {
  const {
    handleFollow: o,
    handleTrackGA4: r
  } = T(), {
    content: p,
    layout: g = "default",
    tagline: m,
    theme: h
  } = e, {
    description: f,
    image: y,
    title: s
  } = p, d = el(e), u = Z(o), v = Z(r), x = e.campaign, $ = dt(h);
  ee(() => {
    t || r({
      action: "imp",
      category: "promopopup",
      customized_parameters: {
        cta_type: $,
        internal_campaign: x,
        step: "1"
      },
      subcategory: ""
    });
  });
  const k = I(() => {
    r({
      action: "click",
      category: "promopopup",
      customized_parameters: {
        cta_type: $,
        internal_campaign: x,
        message: "close button",
        step: "1"
      },
      subcategory: ""
    }), a();
  }, [x, $, a, r]);
  return H(() => {
    const {
      tid: w,
      tids: S = [],
      type: b
    } = e;
    t && u.current && v.current && Te(b) && (u.current({
      action: X.Follow,
      callback: () => {
        v.current({
          action: "sys",
          category: "follow",
          customized_parameters: {
            action_type: "follow",
            follow_type: "topic",
            internal_campaign: x,
            topic_id: w ?? S.join(", "),
            trigger_point: "ppto"
          },
          subcategory: "result"
        });
      },
      entityIds: w ? [w] : S,
      followType: b
    }), a());
  }, [e, x, t, u, v, a]), t ? null : /* @__PURE__ */ i.createElement(U, {
    BackdropComponent: ne,
    container: n == null ? void 0 : n.current,
    fadeTimeout: 400,
    open: !0,
    "data-qa": "campaign-popup"
  }, /* @__PURE__ */ i.createElement(Xr, {
    $variant: g
  }, /* @__PURE__ */ i.createElement(K, {
    onClose: k
  }), /* @__PURE__ */ i.createElement(re, {
    alt: s,
    src: y
  }), /* @__PURE__ */ i.createElement(le, null, /* @__PURE__ */ i.createElement(ut, {
    dangerouslySetInnerHTML: {
      __html: m
    }
  }), /* @__PURE__ */ i.createElement(be, {
    dangerouslySetInnerHTML: {
      __html: s
    }
  }), /* @__PURE__ */ i.createElement(xe, {
    dangerouslySetInnerHTML: {
      __html: f
    }
  }), d.render({
    followButtonProps: {
      outline: g === "soft" ? z.Filled : z.Outlined,
      size: g === "soft" ? j.Large : j.Normal,
      variant: g === "soft" ? P.Light : P.Dark
    },
    handlePopupClose: a
  }))));
};
ke.displayName = "CampaignPopup";
const tl = (e) => {
  const {
    acquisition: {
      popupState: t
    },
    currentRoute: n,
    handleOpenLoginDialog: a,
    handleRemoveRouteQuery: o,
    userCountry: r,
    userTypeIds: p
  } = T(), g = I(() => o(gr), [o]), m = I((y) => {
    const s = $r(new URL(n, window.location.origin).search);
    if (!s) return;
    const d = Object.values(t.campaigns).find((v) => v.name === s.campaign);
    if (!d) return;
    if (!e.isLoggedIn) {
      const {
        description: v,
        title: x
      } = ge({
        campaignName: d.campaign,
        type: d.type
      });
      a({
        description: v,
        destination: window.location.href,
        ga4CustomParameter: {
          internal_campaign: d.campaign,
          trigger_point: "ppto"
        },
        title: x
      }), g();
      return;
    }
    const u = {
      campaign: d,
      confirmedAction: !0,
      modalContainerReference: e.modalContainerReference,
      onClose: y
    };
    return g(), {
      element: /* @__PURE__ */ i.createElement(ke, u),
      localStorageKey: d.localStorageKey
    };
  }, [n, t.campaigns, e.isLoggedIn, e.modalContainerReference, g, a]), h = I((y) => {
    var s;
    const d = Object.values(t.campaigns).find((v) => Te(v.type) && J({
      config: v,
      userInfo: {
        isLoggedIn: e.isLoggedIn,
        userCountry: r ?? "",
        userTypeIds: p
      }
    }));
    if (!d) return;
    const u = {
      campaign: d,
      modalContainerReference: e.modalContainerReference,
      onClose: y
    };
    return {
      delay: Number.parseInt((s = d.timeout) !== null && s !== void 0 ? s : "0", 10),
      element: /* @__PURE__ */ i.createElement(ke, u),
      localStorageKey: d.localStorageKey
    };
  }, [e.isLoggedIn, e.modalContainerReference, t.campaigns, r, p]);
  return O(() => ({
    getNextFromAction: m,
    getNextFromConfig: h
  }), [h, m]);
}, nl = (e) => /* @__PURE__ */ l.createElement("svg", { width: 56, height: 57, viewBox: "0 0 56 57", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { clipPath: "url(#clip0_2249_45204)" }, /* @__PURE__ */ l.createElement("path", { d: "M0 28C0 12.536 12.536 0 28 0C43.4639 0 56 12.536 56 28C56 43.4639 43.4639 56 28 56C12.536 56 0 43.4639 0 28Z", fill: "#FFCA05" }), /* @__PURE__ */ l.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.6839 30.8533L24.4082 41.5782L42.2491 23.7374C43.1603 22.8262 43.1603 21.3488 42.2491 20.4376C41.3377 19.5263 39.8605 19.5263 38.9491 20.4376L24.4082 34.9786L16.9838 27.5537C16.0726 26.6423 14.5952 26.6423 13.6839 27.5535C12.7727 28.4646 12.7727 29.9421 13.6839 30.8533Z", fill: "#001246" })), /* @__PURE__ */ l.createElement("defs", null, /* @__PURE__ */ l.createElement("clipPath", { id: "clip0_2249_45204" }, /* @__PURE__ */ l.createElement("rect", { width: 56, height: 56, fill: "white", transform: "translate(0 0.346191)" })))), al = /* @__PURE__ */ c($e, {
  target: "e1o2l8zf6"
})("block-size:43.65px;min-inline-size:252px;margin-block-start:40px;color:#ffffff;font-weight:400;font-size:16px;font-family:", C, ";line-height:19px;border:1px solid #4585ff;border-radius:3px;background:#001246;cursor:pointer;", (e) => e.theme.breakpoints.up("tablet"), "{inline-size:270px;}"), ol = /* @__PURE__ */ c("div", {
  target: "e1o2l8zf5"
})("position:relative;display:flex;justify-content:center;align-items:center;inline-size:calc(100vw - 20px);margin:auto;background-color:#ffffff;outline:none;", (e) => e.theme.breakpoints.up("mobile"), "{inline-size:335px;}", (e) => e.theme.breakpoints.up("tablet"), "{inline-size:440px;}"), il = /* @__PURE__ */ c("div", {
  target: "e1o2l8zf3"
})("display:flex;flex-flow:column;justify-content:center;align-items:center;max-inline-size:300px;padding-block:40px;padding-inline:20px;text-align:center;", (e) => e.theme.breakpoints.up("tablet"), "{max-inline-size:440px;padding:48px;}"), rl = /* @__PURE__ */ c("div", {
  target: "e1o2l8zf2"
})("margin-block-start:16px;color:#001246;font-weight:900;font-size:20px;font-family:", Y, ";line-height:24px;", (e) => e.theme.breakpoints.up("tablet"), "{inline-size:320px;font-size:24px;line-height:29px;}"), ll = /* @__PURE__ */ c("div", {
  target: "e1o2l8zf1"
})("max-inline-size:250px;margin-block-start:17px;color:#000000;font-weight:400;font-size:14px;font-family:", C, ";line-height:20px;text-align:center;", (e) => e.theme.breakpoints.up("tablet"), "{max-inline-size:100%;font-size:16px;line-height:22px;}ul{display:flex;flex-flow:column;justify-content:center;align-items:center;list-style:disc inside;}"), sl = /* @__PURE__ */ c("a", {
  target: "e1o2l8zf0"
})({
  name: "10up1tw",
  styles: "color:#4585ff;text-decoration:underline;cursor:pointer"
}), mt = ({
  config: e,
  modalContainerReference: t,
  onClose: n
}) => {
  const {
    currentRoute: a
  } = T(), o = a.toLowerCase() === "mynews", r = () => o ? e.button.inMyNewsText : e.button.otherPageText;
  return /* @__PURE__ */ i.createElement(U, {
    BackdropComponent: ne,
    container: t == null ? void 0 : t.current,
    fadeTimeout: 400,
    open: !0,
    "data-qa": "my-news-completion-popup"
  }, /* @__PURE__ */ i.createElement(ol, null, /* @__PURE__ */ i.createElement(K, {
    onClose: () => {
      n();
    }
  }), /* @__PURE__ */ i.createElement(il, null, /* @__PURE__ */ i.createElement(nl, null), /* @__PURE__ */ i.createElement(rl, {
    dangerouslySetInnerHTML: {
      __html: e.headline
    }
  }), /* @__PURE__ */ i.createElement(ll, null, Ut(e.description, {
    replace: (p) => p instanceof Wt && p.name === "download-link" ? /* @__PURE__ */ i.createElement(sl, {
      onClick: () => {
        window.open("https://scmp.onelink.me/3586748601/aalocqf2", "_blank");
      }
    }, "download") : p
  })), /* @__PURE__ */ i.createElement(al, {
    dangerouslySetInnerHTML: {
      __html: r()
    },
    onClick: () => {
      n();
    },
    url: "/mynews"
  }))));
};
mt.displayName = "MyNewsCompletionPopup";
const cl = (e) => {
  var t, n;
  const {
    acquisition: {
      popupState: a
    },
    currentPageType: o,
    handleTrackGA4: r,
    hasEnoughFollowedItems: p,
    initialHasEnoughFollowedItems: g
  } = T(), m = O(() => {
    var s;
    return (
      // 1. Is not posties pages
      !It.includes(o) && // 2. Drupal Config is on
      ((s = a.myNews.config) === null || s === void 0 || (s = s.completion_popup) === null || s === void 0 ? void 0 : s.isEnabled) && // 3. Is Logged in
      e.isLoggedIn && // 4. Followed items length is larger than threshold
      p && // 5. Snapshot list length is not larger than threshold (So if the user already followed more than threshold in the beginning, the popup will not show)
      !g
    );
  }, [o, p, g, e.isLoggedIn, (t = a.myNews.config) === null || t === void 0 || (t = t.completion_popup) === null || t === void 0 ? void 0 : t.isEnabled]), h = I((s) => {
    var d, u, v;
    if (!((d = a.myNews) !== null && d !== void 0 && d.completion) || !m) return;
    const x = (u = a.myNews) === null || u === void 0 || (u = u.completion) === null || u === void 0 ? void 0 : u.localStorageKey;
    if (localStorage.getItem(x) !== null) return;
    const k = {
      config: (v = a.myNews) === null || v === void 0 ? void 0 : v.completion,
      modalContainerReference: e.modalContainerReference,
      onClose: s
    };
    return {
      element: /* @__PURE__ */ i.createElement(mt, k),
      localStorageKey: x
    };
  }, [m, e.modalContainerReference, (n = a.myNews) === null || n === void 0 ? void 0 : n.completion]), f = Z(!1);
  return H(() => {
    f.current || m && (r({
      action: "sys",
      category: "mynews",
      customized_parameters: {
        trigger_point: "mynews_setup"
      },
      subcategory: "completion"
    }), f.current = !0);
  }, [m, r]), O(() => ({
    getNextFromConfig: h
  }), [h]);
};
function pl(e) {
  var t;
  const a = (t = te.parse(e, {
    ignoreQueryPrefix: !0
  }).action) === null || t === void 0 ? void 0 : t.follow_topic_package;
  if (!(!a || a.checkedIndex.length === 0))
    return a;
}
function ul(e) {
  const t = {
    action: {
      follow_topic_package: e
    }
  };
  return te.stringify(t, {
    arrayFormat: "comma"
  });
}
const gl = (e) => /* @__PURE__ */ l.createElement("svg", { width: 24, height: 24, xmlns: "http://www.w3.org/2000/svg", fill: "231F20", xmlSpace: "preserve", ...e }, /* @__PURE__ */ l.createElement("path", { d: "M9.835 12.715H5.537v1.436h4.298v4.303h1.441v-4.303h4.298v-1.436h-4.298V8.412H9.835v4.303z" }), /* @__PURE__ */ l.createElement("path", { d: "M.5 5.546V21.32c0 1.195.97 2.171 2.17 2.171h15.776c1.195 0 2.171-.97 2.171-2.17v-2.093h.712a2.174 2.174 0 0 0 2.172-2.172V2.68A2.176 2.176 0 0 0 21.329.508H6.951a2.168 2.168 0 0 0-2.165 2.17v.697H2.67a2.17 2.17 0 0 0-2.172 2.17zm17.94-2.171H6.24v-.696c0-.393.32-.713.712-.713H21.33c.393 0 .713.32.713.713v14.378c0 .393-.32.713-.713.713h-.712V5.546a2.178 2.178 0 0 0-2.177-2.171zM1.952 21.32V5.546c0-.393.32-.713.713-.713H18.44c.393 0 .713.32.713.713V21.32c0 .393-.32.713-.713.713H2.665a.713.713 0 0 1-.713-.713z" })), ft = (e) => /* @__PURE__ */ l.createElement("svg", { width: 24, height: 25, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("circle", { cx: 12, cy: 12.5, r: 10, fill: "white" }), /* @__PURE__ */ l.createElement("path", { d: "M20.4844 4.01562C18.1406 1.67188 15.3125 0.5 12 0.5C8.6875 0.5 5.85938 1.67188 3.51562 4.01562C1.17188 6.35938 0 9.1875 0 12.5C0 15.8125 1.17188 18.6406 3.51562 20.9844C5.85938 23.3281 8.6875 24.5 12 24.5C15.3125 24.5 18.1406 23.3281 20.4844 20.9844C22.8281 18.6406 24 15.8125 24 12.5C24 9.1875 22.8281 6.35938 20.4844 4.01562ZM18.0938 9.5L10.5 17.0938L5.90625 12.5C5.4375 12.0312 5.4375 11.5625 5.90625 11.0938C6.34375 10.6562 6.8125 10.6562 7.3125 11.0938L10.5 14.2812L16.6875 8.09375C17.1875 7.65625 17.6562 7.65625 18.0938 8.09375C18.5625 8.5625 18.5625 9.03125 18.0938 9.5Z", fill: "#001246" })), dl = /* @__PURE__ */ c("div", {
  target: "e19uvh0513"
})({
  name: "g5nysp",
  styles: "position:relative;inline-size:calc(100vw - 20px);max-inline-size:600px;margin:auto"
}), ht = /* @__PURE__ */ c("div", {
  target: "e19uvh0512"
})("display:flex;flex-flow:column nowrap;justify-content:center;align-items:center;inline-size:calc(100vw - 20px);max-inline-size:600px;padding-block:24px;padding-inline:20px;background-color:#f6f6f6;>*+*{margin-block-start:12px;}", (e) => e.theme.breakpoints.up("tablet"), "{margin-inline:unset;padding-inline:100px;}"), ml = /* @__PURE__ */ c(ht, {
  target: "e19uvh0511"
})({
  name: "2qm2l6",
  styles: "padding-block:24px"
}), yt = /* @__PURE__ */ c("div", {
  target: "e19uvh0510"
})("color:#001149;font-weight:300;font-size:24px;font-family:", C, ";line-height:28px;text-align:center;"), fl = /* @__PURE__ */ c(yt, {
  target: "e19uvh059"
})({
  name: "mmvz9h",
  styles: "font-weight:400"
}), hl = /* @__PURE__ */ c("div", {
  target: "e19uvh058"
})({
  name: "4vohe2",
  styles: ">*+*{margin-block-start:16px;}"
}), yl = /* @__PURE__ */ c(gl, {
  target: "e19uvh057"
})({
  name: "eykqtd",
  styles: "flex:none"
}), Ce = /* @__PURE__ */ c(ft, {
  target: "e19uvh056"
})({
  name: "eykqtd",
  styles: "flex:none"
}), vl = /* @__PURE__ */ c(ft, {
  target: "e19uvh055"
})({
  name: "zufsyu",
  styles: "flex:none;inline-size:56px;block-size:56px;circle{fill:#001246;}path{fill:#ffca05;}"
}), bl = /* @__PURE__ */ c("span", {
  target: "e19uvh054"
})("flex:1;font-weight:700;font-size:16px;font-family:", C, ";font-style:normal;line-height:19px;"), xl = /* @__PURE__ */ c("div", {
  target: "e19uvh053"
})("display:flex;flex-flow:row nowrap;gap:10px;justify-content:space-between;align-items:center;block-size:51px;padding-block:8px;padding-inline:20px 16px;border-radius:30px;cursor:pointer;", (e) => e.theme.breakpoints.up("mobile"), "{inline-size:312px;}", (e) => e.$isChecked ? /* @__PURE__ */ L("background:#ffca05;", Ce, "{circle{fill:#ffffff;}path{fill:#001246;}}", "") : /* @__PURE__ */ L("border:1px solid #bbbbbb;background:#ffffff;", Ce, "{opacity:0.2;circle{fill:#a1a1a1;}path{fill:#a1a1a1;}}", ""), ";"), Ke = /* @__PURE__ */ c("div", {
  target: "e19uvh052"
})("color:#000000;font-weight:400;font-size:14px;font-family:", C, ";line-height:18px;text-align:center;");
var wl = {
  name: "17b7sab",
  styles: "color:#ffffff;background:#001246;cursor:pointer"
}, _l = {
  name: "xal2p",
  styles: "color:#000000;background:#e5e5e5;cursor:not-allowed"
};
const Ue = /* @__PURE__ */ c("button", {
  target: "e19uvh051"
})("align-items:center;padding-block:15px;padding-inline:50px;font-size:16px;font-family:", C, ";text-align:center;text-transform:uppercase;border:none;border-radius:4px;", (e) => e.$isDisabled ? _l : wl, ";"), kl = /* @__PURE__ */ c("a", {
  target: "e19uvh050"
})("color:#001246;font-size:14px;font-family:", C, ";font-style:normal;line-height:18px;text-align:center;text-decoration-line:underline;cursor:pointer;"), We = ({
  confirmedConfig: e,
  modalContainerReference: t,
  onClose: n,
  topicPackageFollow: a
}) => {
  const o = a.stepForm.step1, r = a.stepForm.step2, {
    displayName: p,
    key: g,
    shouldShowThankYouPopup: m,
    trackingActionName: h
  } = a, {
    config: f,
    handleFollow: y,
    handleOpenLoginDialog: s,
    handleRoutePush: d,
    handleTrackGA4: u,
    user: v
  } = T(), x = h;
  ee(() => {
    if (e) {
      m && u({
        action: "imp",
        category: "promopopup",
        customized_parameters: {
          cta_type: "follow",
          internal_campaign: x,
          step: "2"
        },
        subcategory: ""
      }), R(), m || n();
      return;
    }
    u({
      action: "imp",
      category: "promopopup",
      customized_parameters: {
        cta_type: "follow",
        internal_campaign: x,
        step: "1"
      },
      subcategory: ""
    });
  });
  const $ = () => {
    u({
      action: "click",
      category: "promopopup",
      customized_parameters: {
        cta_type: "follow",
        internal_campaign: x,
        message: "close button",
        step: "1"
      },
      subcategory: ""
    }), n();
  }, [k, w] = $t(o.topicPackageDefaultOptionList.map((E, _) => e != null && e.checkedItemIndex ? {
    ...E,
    checked: e.checkedItemIndex.includes(_)
  } : {
    ...E,
    checked: E.defaultChecked
  }));
  H(() => {
    w.reset();
  }, [w, o.topicPackageDefaultOptionList, e == null ? void 0 : e.checkedItemIndex]);
  const S = (E) => {
    const _ = k[E];
    w.updateAt(E, {
      ..._,
      checked: !_.checked
    }), u({
      action: "click",
      category: "follow",
      customized_parameters: {
        action_type: _.checked ? "unfollow" : "follow",
        follow_type: "topic_package",
        internal_campaign: x,
        package_name: _.optionLabel,
        topic_id: _.topicIdList.join(", "),
        trigger_point: "ppto"
      },
      subcategory: ""
    });
  }, [b, ae] = V((e == null ? void 0 : e.checkedItemIndex) && e.checkedItemIndex.length > 0), R = I(() => {
    if (!v) {
      const _ = k.reduce((Pe, _t, kt) => (_t.checked && Pe.push(kt), Pe), []), A = new URL(window.location.origin + window.location.pathname);
      A.search = ul({
        checkedIndex: _,
        configKey: g
      });
      const {
        description: xt,
        title: wt
      } = ge({
        campaignName: p,
        type: "topics"
      });
      s({
        description: xt,
        destination: A.toString(),
        ga4CustomParameter: {
          internal_campaign: x,
          trigger_point: "ppto"
        },
        title: wt
      });
      return;
    }
    const E = k.filter((_) => _.checked);
    y({
      action: X.Follow,
      callback: () => {
        const _ = E.map((A) => A.optionLabel).join(", ");
        u({
          action: "sys",
          category: "follow",
          customized_parameters: {
            action_type: "follow",
            follow_type: "topic_package",
            internal_campaign: x,
            package_name: _,
            topic_id: E.flatMap((A) => A.topicIdList).join(", "),
            trigger_point: "ppto"
          },
          subcategory: "result"
        });
      },
      entityIds: E.flatMap((_) => _.topicIdList),
      followType: it.Topic
    }), ae(!0);
  }, [x, p, y, s, u, k, g, v]), N = k.every((E) => !E.checked), F = () => {
    N || (u({
      action: "click",
      category: "promopopup",
      customized_parameters: {
        cta_type: "follow",
        internal_campaign: x,
        message: o.buttonText,
        step: "1"
      },
      subcategory: ""
    }), R(), m || n());
  }, de = () => {
    u({
      action: "click",
      category: "promopopup",
      customized_parameters: {
        cta_type: "follow",
        internal_campaign: x,
        message: r.buttonText,
        step: "2"
      },
      subcategory: ""
    }), n();
  }, me = (E) => {
    E == null || E.preventDefault();
    const _ = "/manage/following?module=topic_package&pgtype=article";
    u({
      action: "click",
      category: "promopopup",
      customized_parameters: {
        cta_type: "follow",
        destination_url: _,
        internal_campaign: x,
        message: r.bottomLinkText,
        step: "2"
      },
      subcategory: ""
    });
    const A = `${f.accounts.host}${_}`;
    d(A, {
      isExternal: !0
    });
  };
  return !m && b ? null : /* @__PURE__ */ i.createElement(U, {
    BackdropComponent: ne,
    container: t == null ? void 0 : t.current,
    fadeTimeout: 400,
    open: !0,
    "data-qa": "topic-package-follow-popup"
  }, /* @__PURE__ */ i.createElement(dl, null, /* @__PURE__ */ i.createElement(K, {
    onClose: $
  }), b ? /* @__PURE__ */ i.createElement(ml, null, /* @__PURE__ */ i.createElement(vl, null), /* @__PURE__ */ i.createElement(fl, {
    dangerouslySetInnerHTML: {
      __html: r.title
    }
  }), /* @__PURE__ */ i.createElement(Ke, {
    dangerouslySetInnerHTML: {
      __html: r.description
    }
  }), /* @__PURE__ */ i.createElement(Ue, {
    dangerouslySetInnerHTML: {
      __html: r.buttonText
    },
    onClick: de
  }), /* @__PURE__ */ i.createElement(kl, {
    dangerouslySetInnerHTML: {
      __html: r.bottomLinkText
    },
    onClick: me
  })) : /* @__PURE__ */ i.createElement(ht, null, /* @__PURE__ */ i.createElement(yt, {
    dangerouslySetInnerHTML: {
      __html: o.title
    }
  }), /* @__PURE__ */ i.createElement(hl, null, o.topicPackageDefaultOptionList.map((E, _) => /* @__PURE__ */ i.createElement(xl, {
    $isChecked: k[_].checked,
    key: _,
    onClick: () => S(_)
  }, /* @__PURE__ */ i.createElement(yl, null), /* @__PURE__ */ i.createElement(bl, {
    dangerouslySetInnerHTML: {
      __html: E.optionLabel
    }
  }), /* @__PURE__ */ i.createElement(Ce, null)))), /* @__PURE__ */ i.createElement(Ke, {
    dangerouslySetInnerHTML: {
      __html: o.description
    }
  }), /* @__PURE__ */ i.createElement(Ue, {
    $isDisabled: N,
    dangerouslySetInnerHTML: {
      __html: o.buttonText
    },
    onClick: F
  }))));
}, Cl = ["action"];
function Sl(e) {
  const {
    acquisition: {
      popupState: t
    },
    currentRoute: n,
    handleOpenLoginDialog: a,
    handleRemoveRouteQuery: o,
    userCountry: r,
    userTypeIds: p
  } = T(), g = I(() => o(Cl), [o]), m = I((y) => {
    const s = pl(new URL(n, window.location.origin).search);
    if (!s) return;
    const d = t.topicPackageFollows[s.configKey];
    if (!d) return;
    if (!e.isLoggedIn) {
      const {
        description: v,
        title: x
      } = ge({
        campaignName: d.displayName,
        type: "topics"
      });
      a({
        description: v,
        destination: window.location.href,
        ga4CustomParameter: {
          internal_campaign: d == null ? void 0 : d.trackingActionName,
          trigger_point: "ppto"
        },
        title: x
      }), g();
      return;
    }
    const u = {
      confirmedConfig: {
        checkedItemIndex: s.checkedIndex
      },
      modalContainerReference: e.modalContainerReference,
      onClose: y,
      topicPackageFollow: {
        ...d,
        key: s.configKey
      }
    };
    return g(), {
      element: /* @__PURE__ */ i.createElement(We, u),
      localStorageKey: d.localStorageKey
    };
  }, [n, a, g, e.isLoggedIn, e.modalContainerReference, t.topicPackageFollows]), h = I((y) => {
    const s = Object.entries(t.topicPackageFollows).find(([x, $]) => J({
      config: $,
      userInfo: {
        isLoggedIn: e.isLoggedIn,
        userCountry: r ?? "",
        userTypeIds: p
      }
    }));
    if (!s) return;
    const [d, u] = s, v = {
      modalContainerReference: e.modalContainerReference,
      onClose: y,
      topicPackageFollow: {
        ...u,
        key: d
      },
      trackingName: u.trackingActionName
    };
    return {
      delay: Number.parseInt(u.timeout, 10),
      element: /* @__PURE__ */ i.createElement(We, v),
      localStorageKey: u.localStorageKey
    };
  }, [e.isLoggedIn, e.modalContainerReference, t.topicPackageFollows, r, p]);
  return O(() => ({
    getNextFromAction: m,
    getNextFromConfig: h
  }), [h, m]);
}
const El = (e) => {
  var t, n;
  const a = te.parse(e, {
    ignoreQueryPrefix: !0
  });
  return Dt(Object.keys((t = (n = a.action) === null || n === void 0 ? void 0 : n.ppto_why_reg) !== null && t !== void 0 ? t : {}));
}, zl = (e) => {
  const t = new URL(window.location.origin + window.location.pathname);
  return t.search = `action[ppto_why_reg][${e}]`, t.toString();
}, Il = (e) => /* @__PURE__ */ l.createElement("svg", { viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("rect", { width: 40, height: 40, rx: 20, fill: "#C79A00", fillOpacity: 0.2 }), /* @__PURE__ */ l.createElement("path", { d: "m27.436 11.764c0.5983 0.6207 0.8979 1.3731 0.8979 2.2557v15.147l-8.2615-5.2997-8.4052 5.2997v-15.147c0-0.8826 0.2988-1.635 0.8979-2.2557 0.599-0.62 1.3169-0.9311 2.1556-0.9311h10.56c0.8374 0 1.556 0.3111 2.155 0.9311z", clipRule: "evenodd", fill: "#001246", fillRule: "evenodd" })), Ll = (e) => /* @__PURE__ */ l.createElement("svg", { viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("rect", { width: 40, height: 40, rx: 20, fill: "#C79A00", fillOpacity: 0.2 }), /* @__PURE__ */ l.createElement("path", { d: "m27.444 11.764c0.5924 0.6207 0.8889 1.3731 0.8889 2.2557v8.8445c0 0.8839-0.2965 1.6356-0.8889 2.2556-0.5929 0.6214-1.3077 0.9311-2.1448 0.9311h-8.7172l-4.9158 3.1154v-15.147c0-0.8826 0.2958-1.635 0.8888-2.2557 0.593-0.62 1.3077-0.9311 2.1442-0.9311h10.6c0.8371 0 1.5519 0.3111 2.1448 0.9311z", clipRule: "evenodd", fill: "#001246", fillRule: "evenodd" })), Tl = (e) => /* @__PURE__ */ l.createElement("svg", { width: 21, height: 16, viewBox: "0 0 21 16", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ l.createElement("path", { fill: "#FEFEFE", d: "M0 15.984h20.593V0H0z" }), /* @__PURE__ */ l.createElement("path", { fill: "#FFCA05", d: "M1.777 14.194h7.627V1.788H1.777z" }), /* @__PURE__ */ l.createElement("path", { fill: "#001246", d: "M11.189 14.194h7.627V1.788H11.19z" }))), $l = (e) => /* @__PURE__ */ l.createElement("svg", { viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("rect", { width: 40, height: 40, rx: 20, fill: "#C79A00", fillOpacity: 0.2 }), /* @__PURE__ */ l.createElement("path", { d: "m27.071 27.07c1.9529-1.9529 2.9293-4.3093 2.9293-7.07 0-2.76-0.9764-5.1171-2.9293-7.0707-1.9536-1.9529-4.3107-2.9293-7.0707-2.9293-2.7607 0-5.1171 0.9764-7.07 2.9293-1.9536 1.9536-2.93 4.3107-2.93 7.0707 0 2.7607 0.9764 5.1171 2.93 7.07 1.9529 1.9536 4.3093 2.93 7.07 2.93 2.76 0 5.1171-0.9764 7.0707-2.93zm-3.0317-7.4934h-3.555v-3.555h-1.0157v3.555h-3.5543v1.0157h3.5543v3.5543h1.0157v-3.5543h3.555v-1.0157z", clipRule: "evenodd", fill: "#001246", fillRule: "evenodd" })), Pl = (e) => /* @__PURE__ */ l.createElement("svg", { viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("rect", { width: 40, height: 40, rx: 20, fill: "#C79A00", fillOpacity: 0.2 }), /* @__PURE__ */ l.createElement("path", { d: "m30 17.847c0 0.1691-0.1122 0.3667-0.3358 0.5914l-4.3279 4.2636 1.0081 6.0369v0.2115c0 0.1976-0.0415 0.3374-0.126 0.4223-0.0838 0.1405-0.196 0.2107-0.3358 0.2107-0.1122 0-0.2804-0.0556-0.5048-0.169l-5.3782-2.8286-5.3782 2.8286c-0.2243 0.1134-0.3918 0.169-0.504 0.169-0.1683 0-0.2943-0.0702-0.378-0.2107-0.0838-0.0849-0.126-0.2247-0.126-0.4223 0-0.0849 0.0138-0.1544 0.0422-0.2115l1.0081-6.0369-4.3694-4.2636c-0.196-0.3096-0.2943-0.5072-0.2943-0.5914 0-0.3087 0.2243-0.4925 0.6723-0.5488l6.0505-0.8863 2.6891-5.4887c0.1674-0.3374 0.3634-0.5064 0.5877-0.5064 0.2244 0 0.4203 0.169 0.5885 0.5064l2.6891 5.4887 6.0505 0.8863c0.448 0.0563 0.6723 0.2401 0.6723 0.5488z", clipRule: "evenodd", fill: "#001246", fillRule: "evenodd" })), Nl = /* @__PURE__ */ c("div", {
  target: "efitneq14"
})("position:relative;inline-size:300px;min-block-size:449px;margin:auto;padding-block:16px;padding-inline:24px;background-color:#f1ecdc;", (e) => e.theme.breakpoints.up("tablet"), "{inline-size:600px;max-inline-size:600px;min-block-size:407px;}"), Ol = /* @__PURE__ */ c("div", {
  target: "efitneq13"
})("display:flex;flex-flow:column;justify-content:center;align-items:center;#sa-login-widget{inline-size:100%;", (e) => e.theme.breakpoints.up("tablet"), "{max-inline-size:252px;}}.sa-google-login-button{margin-block-end:0;}.sa-login-widget{inline-size:100%;}"), Rl = /* @__PURE__ */ c("div", {
  target: "efitneq12"
})("max-inline-size:252px;margin-block:16px 0;color:#001246;font-weight:900;font-size:16px;font-family:", Y, ";line-height:20px;text-align:center;", (e) => e.theme.breakpoints.up("tablet"), "{max-inline-size:480px;margin-block:16px 0;font-weight:900;font-size:24px;font-family:", Y, ";line-height:30.17px;}"), Fl = /* @__PURE__ */ c(Tl, {
  target: "efitneq11"
})({
  name: "19niaop",
  styles: "inline-size:33px;block-size:25px"
}), Al = /* @__PURE__ */ c("div", {
  target: "efitneq10"
})({
  name: "37aeay",
  styles: "display:flex;flex-flow:row;justify-content:center;align-items:center;margin-block:16px 0"
}), jl = /* @__PURE__ */ c(Il, {
  target: "efitneq9"
})({
  name: "8q934",
  styles: "inline-size:40px;block-size:40px;margin-inline:4px"
}), Ml = /* @__PURE__ */ c(Ll, {
  target: "efitneq8"
})({
  name: "8q934",
  styles: "inline-size:40px;block-size:40px;margin-inline:4px"
}), Hl = /* @__PURE__ */ c($l, {
  target: "efitneq7"
})({
  name: "8q934",
  styles: "inline-size:40px;block-size:40px;margin-inline:4px"
}), ql = /* @__PURE__ */ c(Pl, {
  target: "efitneq6"
})({
  name: "8q934",
  styles: "inline-size:40px;block-size:40px;margin-inline:4px"
}), Dl = /* @__PURE__ */ c("div", {
  target: "efitneq5"
})("max-inline-size:360px;margin-block:16px 0;margin-inline:6px 0;", (e) => e.theme.breakpoints.up("tablet"), "{margin-block:16px 0;margin-inline:0;}"), Bl = /* @__PURE__ */ c("div", {
  target: "efitneq4"
})("display:flex;flex-flow:row;justify-content:flex-start;align-items:flex-start;padding-block:0 8px;color:#001246;font-size:14px;font-family:", C, ";line-height:130%;&:last-of-type{padding:0;}", (e) => e.theme.breakpoints.up("tablet"), "{font-size:16px;font-family:", C, ";}"), Gl = /* @__PURE__ */ c("div", {
  target: "efitneq3"
})({
  name: "823mde",
  styles: "margin-inline:0 7px"
}), Kl = /* @__PURE__ */ c("span", {
  target: "efitneq2"
})(""), Ul = /* @__PURE__ */ c("div", {
  target: "efitneq1"
})({
  name: "hsrr3n",
  styles: "inline-size:100%;margin-block:16px 0;.sa-login-widget-title{display:none;}"
}), Wl = /* @__PURE__ */ c("div", {
  target: "efitneq0"
})("margin-block:16px 0;color:#4585ff;font-size:14px;font-family:", C, ";cursor:pointer;border-block-end:1px #4585ff solid;"), Se = ({
  modalContainerReference: e,
  onClose: t,
  whyRegister: n
}) => {
  const a = n.content.introductions, o = Object.keys(a).sort((u, v) => u.localeCompare(v)), {
    config: r,
    handleOpenLoginDialog: p,
    handleTrackGA4: g
  } = T(), m = O(() => zl(n.trackingActionName), [n.trackingActionName]), h = I((u) => {
    if (!u) return;
    const v = new URL(r.accounts.host);
    Oe.init({
      AUTH_CALLBACK_URL: `${r.accounts.authCallbackUrl}`,
      DEBUG_LOG: !1,
      DESTINATION: m,
      MIXPANEL_TOKEN: `${r.mixpanel.token}`,
      RECAPTCHA_CONTAINER_ID: "",
      RECAPTCHA_SITE_KEY: `${r.recaptcha.siteKey}`,
      REGISTER_CALLBACK_URL: `${r.accounts.registerCallbackUrl}`,
      SCMP_ACCOUNT_HOST: v.host,
      SCMP_ACCOUNT_PROTOCOL: v.protocol.slice(0, -1)
    });
    const x = At();
    Oe.initLoginWidget(u.id, {
      destination: m,
      loginDescription: "",
      loginWithEmail: !1,
      sendWelcomeEmail: !1,
      thirdPartySignInOptions: {
        triggerPoint: "ppto",
        withGoogle: !x
      },
      title: ""
    });
  }, [r.accounts.authCallbackUrl, r.accounts.host, r.accounts.registerCallbackUrl, r.mixpanel.token, r.recaptcha.siteKey, m]), f = n.trackingActionName;
  ee(() => {
    g({
      action: "imp",
      category: "promopopup",
      customized_parameters: {
        cta_type: "login_register",
        internal_campaign: f,
        step: "1"
      },
      subcategory: ""
    });
  });
  const y = () => {
    g({
      action: "click",
      category: "promopopup",
      customized_parameters: {
        cta_type: "login_register",
        internal_campaign: f,
        message: "Sign in with Google",
        step: "1"
      },
      subcategory: ""
    });
  }, s = () => {
    g({
      action: "click",
      category: "promopopup",
      customized_parameters: {
        cta_type: "login_register",
        internal_campaign: f,
        message: "Sign in with other methods",
        step: "1"
      },
      subcategory: ""
    }), t(), p({
      destination: m,
      ga4CustomParameter: {
        internal_campaign: f,
        trigger_point: "ppto"
      }
    });
  }, d = () => {
    g({
      action: "click",
      category: "promopopup",
      customized_parameters: {
        cta_type: "login_register",
        internal_campaign: f,
        message: "close button",
        step: "1"
      },
      subcategory: ""
    }), t();
  };
  return /* @__PURE__ */ i.createElement(U, {
    BackdropComponent: ne,
    container: e == null ? void 0 : e.current,
    fadeTimeout: 400,
    open: !0,
    "data-qa": "why-register-popup"
  }, /* @__PURE__ */ i.createElement(Nl, null, /* @__PURE__ */ i.createElement(K, {
    onClose: d
  }), /* @__PURE__ */ i.createElement(Ol, null, /* @__PURE__ */ i.createElement(Fl, null), /* @__PURE__ */ i.createElement(Rl, {
    dangerouslySetInnerHTML: {
      __html: n.content.title
    }
  }), /* @__PURE__ */ i.createElement(Al, null, /* @__PURE__ */ i.createElement(Hl, null), /* @__PURE__ */ i.createElement(jl, null), /* @__PURE__ */ i.createElement(Ml, null), /* @__PURE__ */ i.createElement(ql, null)), /* @__PURE__ */ i.createElement(Dl, null, o.map((u) => /* @__PURE__ */ i.createElement(Bl, {
    key: u
  }, /* @__PURE__ */ i.createElement(Gl, null, `${u}. `), /* @__PURE__ */ i.createElement(Kl, {
    dangerouslySetInnerHTML: {
      __html: a[u]
    }
  })))), /* @__PURE__ */ i.createElement(Ul, {
    id: "social-login-widget",
    onClick: y,
    ref: h
  }), /* @__PURE__ */ i.createElement(Wl, {
    onClick: s
  }, "Sign in with other methods"))));
};
Se.displayName = "WhyRegisterPopup";
const Ql = ["action"], Vl = (e) => {
  const {
    acquisition: {
      popupState: t
    },
    currentRoute: n,
    handleRemoveRouteQuery: a,
    hasWhyRegisterPPTOHomepagePositionIntersected: o,
    userCountry: r,
    userTypeIds: p
  } = T(), g = I(() => {
    El(new URL(n, window.location.origin).search) && a(Ql);
  }, [n, a]), m = I((y) => {
    var s;
    const d = Object.values(t.whyRegister).find((v) => !v.positioningTrigger && J({
      config: v,
      userInfo: {
        isLoggedIn: e.isLoggedIn,
        userCountry: r ?? "",
        userTypeIds: p
      }
    }));
    if (!d) return;
    const u = {
      modalContainerReference: e.modalContainerReference,
      onClose: y,
      whyRegister: d
    };
    return {
      delay: Number.parseInt((s = d.timeout) !== null && s !== void 0 ? s : "0", 10),
      element: /* @__PURE__ */ i.createElement(Se, u),
      localStorageKey: d.localStorageKey,
      updateLocalStorageOnShow: !0
    };
  }, [e.isLoggedIn, e.modalContainerReference, t.whyRegister, r, p]), h = I((y) => {
    var s;
    const d = Object.values(t.whyRegister).find((v) => v.positioningTrigger && J({
      config: v,
      userInfo: {
        isLoggedIn: e.isLoggedIn,
        userCountry: r ?? "",
        userTypeIds: p
      }
    }));
    if (!d || !o) return;
    const u = {
      modalContainerReference: e.modalContainerReference,
      onClose: y,
      whyRegister: d
    };
    return {
      delay: Number.parseInt((s = d.timeout) !== null && s !== void 0 ? s : "0", 10),
      element: /* @__PURE__ */ i.createElement(Se, u),
      localStorageKey: d.localStorageKey,
      updateLocalStorageOnShow: !0
    };
  }, [o, e.isLoggedIn, e.modalContainerReference, t.whyRegister, r, p]);
  return O(() => ({
    getNextFromAction: g,
    getNextFromConfig: m,
    getNextFromScrollPosition: h
  }), [g, m, h]);
}, vt = ({
  configEnvironmentSlug: e,
  queryReference: t,
  ...n
}) => {
  var a;
  const {
    currentRouteWithoutQuerystring: o
  } = T(), r = Et(bt, t);
  Zt({
    configEnvironmentSlug: e
  }, r), H(() => {
    o && Lt("event", "optimize.triggerCampaign");
  }, [o]);
  const p = tl(n), g = Tr(n), m = Vl(n), h = Sl(n), f = cl(n), y = O(() => ({
    [W.AcquisitionNewsletter]: g,
    [W.Campaign]: p,
    [W.MyNewsCompletion]: f,
    [W.TopicPackageFollow]: h,
    [W.WhyRegister]: m
  }), [g, p, f, h, m]), {
    popup: s
  } = vr(y, n);
  return (a = s == null ? void 0 : s.element) !== null && a !== void 0 ? a : null;
};
vt.displayName = "AcquisitionPopupContainerDisplay";
const bt = Ve;
function Ee() {
  return Ee = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) ({}).hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  }, Ee.apply(null, arguments);
}
const Zl = (e) => {
  const [t, n, a] = zt(bt);
  return H(() => (n({}), a), [n, a]), /* @__PURE__ */ i.createElement(Ct, {
    "data-qa": "acquisition-popup-container"
  }, t && /* @__PURE__ */ i.createElement(vt, Ee({}, e, {
    queryReference: t
  })));
};
Zl.displayName = "AcquisitionPopupContainer";
export {
  Zl as A,
  Ie as B,
  Fn as C,
  et as D,
  nt as E,
  Yr as F,
  Ci as G,
  U as M,
  $e as R,
  M as S,
  Mo as _,
  j as a,
  P as b,
  z as c,
  q as d,
  X as e,
  it as f,
  ge as g,
  Ye as h,
  Te as i,
  ai as j,
  Xo as k,
  ti as l,
  ii as m,
  bn as n,
  Yi as o,
  Je as p,
  Di as q,
  tr as r,
  Xa as s,
  ao as t,
  To as u,
  ze as v,
  $a as w,
  Ki as x,
  Xt as y,
  Vi as z
};
//# sourceMappingURL=component-B0BJ_Mt8.mjs.map
